import axios from 'axios';
import 'url-search-params-polyfill';
import {CONFIG_ENV} from '@/config';

interface TAjaxResponseSimple {
    status: string;
    message: string;
}

export interface TBannerConfig {
    appid: number;
    isClickable: string;   // 'y' | 'n'
    linkUrl: string;
    openInNewTab: string;  // 'y' | 'n'
    imageBase64: string;
}

interface TAjaxResponseGetBanner {
    status: string;
    message: string;
    banner: TBannerConfig;
}

interface TAjaxResponseSaveBanner {
    status: string;
    message: string;
    appid: number;
}

interface TAjaxResponseCurrentBanner {
    status: string;
    message: string;
    hasBanner: boolean;
    isClickable: string;   // 'y' | 'n'
    linkUrl: string;
    openInNewTab: string;  // 'y' | 'n'
    imageBase64: string;
}

export class ServiceBanner {
    public static async getBannerAdmin(): Promise<TAjaxResponseGetBanner> {
        const response = await axios.get(`${CONFIG_ENV.URL_ADMIN.banner}`);
        return response.data;
    }

    public static async saveBanner(payload: {isClickable: string; linkUrl: string; openInNewTab: string}): Promise<TAjaxResponseSaveBanner> {
        const response = await axios.post(`${CONFIG_ENV.URL_ADMIN.banner}`, payload);
        return response.data;
    }

    public static async uploadBannerImage(appid: number, file: File): Promise<TAjaxResponseSimple> {
        const param = new FormData();
        param.append('file', file);
        const config = {
            headers: {'Content-Type': 'multipart/form-data'}
        };
        const response = await axios.post(`${CONFIG_ENV.URL_ADMIN.bannerUploadImage}/${appid}`, param, config);
        return response.data;
    }

    public static async getCurrentBanner(): Promise<TAjaxResponseCurrentBanner> {
        const response = await axios.get(`${CONFIG_ENV.URL_BANNER.current}`);
        return response.data;
    }
}
